/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

export type DidDocumentVerificationMethodItem =
    | Truvity.EcdsaSecp256K1VerificationKey2019
    | Truvity.VerificationMethodMultikey;
